import { getMeta, setMeta } from "./storage";
import { createUuid, isBrowser } from "./types";

/**
 * Identificador estable de esta instalación de la app (plan "Chips de
 * confiabilidad en el detalle de marcas de asistencia"). Se genera una sola
 * vez y se guarda en IndexedDB — sobrevive cierres de pestaña y reinicios del
 * teléfono, pero no una reinstalación ni un teléfono distinto. No identifica
 * a la persona, solo el dispositivo: sirve para que el panel admin pueda
 * señalar "esta marca vino de un teléfono que este empleado nunca había
 * usado", no para probar quién la tocó.
 */

const DEVICE_ID_META_KEY = "device.id";

let cached: string | null = null;

export async function getOrCreateDeviceId(): Promise<string | null> {
  if (!isBrowser()) return null;
  if (cached) return cached;

  const existing = await getMeta<string>(DEVICE_ID_META_KEY).catch(() => undefined);
  if (existing) {
    cached = existing;
    return existing;
  }

  const id = createUuid();
  await setMeta(DEVICE_ID_META_KEY, id).catch(() => {
    // Sin almacenamiento no hay dónde persistirlo: se usa igual para esta
    // sesión (cached), pero la próxima carga generará uno nuevo. No vale la
    // pena bloquear la marca por esto (misma filosofía que capture_location).
  });
  cached = id;
  return id;
}
